import Icon from 'veui/components/Icon'

Icon.register({
  'flow-rollback': {
    paths: [
      {
        d: 'M240 192a40 40 0 1140 40 40 40 0 01-40-40zm425.71 38.29A238.43 238.43 0 00496 160h-2.74l41.37-41.37a32 32 0 00-45.26-45.26l-96 96a32 32 0 000 45.26l96 96a32 32 0 0045.26-45.26L493.26 224H496c97 0 176 78.95 176 176s-79 176-176 176H272c-97 0-176-78.95-176-176a175.28 175.28 0 0182.18-148.94A32 32 0 10144 196.94 239.84 239.84 0 0032 400a240 240 0 00240 240h224a240 240 0 00169.71-409.71z'
      }
    ],
    width: '768',
    height: '768'
  }
})
